export { default } from './ClosestHairColorBar';
